import { Component, OnInit, TemplateRef } from '@angular/core';
import { State } from './state';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { StateService } from './state.service';
 
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { Router } from '@angular/router';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css']
})
export class StateComponent implements OnInit {

  sendMenuId: number;
  sendPageName: string = 'State';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  stateForm: FormGroup;
  states: State[] = [];
  statesactive: State[] = [];
  state: State;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  stateModalRef: BsModalRef;
  operation: string;
  userid: number;
  stateid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  constructor(
    private stateservice: StateService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('State_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('State_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('State_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('State_action');
    } 
  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {
    this.checkIsMenuMapped();
    this.stateForm = this.formBuilder.group({
      stateid: [''],
      state: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  key: string = 'state'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.states = [];
    this.statesactive = [];
    this.stateservice.Get().subscribe(res => {
      this.states = res;
      if (this.showallstatus == true) {
        this.states.forEach(data => {
          if (data.active == 1) {
            this.statesactive.push(data);
          }
        });
        this.states = [];
        this.states = this.statesactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }
  getactiveinactive(showallp) {
    this.statesactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.states.forEach(data => {
        if (data.active == 1) {
          this.statesactive.push(data);
        }
      });
      this.states = [];
      this.states = this.statesactive;
    }
    else {
      this.showall = true;
      this.states = [];
      this.getAll();
    }
  }
  get g() { return this.stateForm.controls; }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedstate");
    let data = arrays.find(ob => ob['name'] === 'State');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedstate","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedstate",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.stateModalRef.hide();
  }

  Post(state: State) {
    
    this.submitted = true;
    // stop here if form is invalid
    //if (this.stateForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.stateForm.errors);
    //}

    if ((state.state.trim() == undefined) || (state.state.trim() == '')) {
      this.toastr.error('State should not be empty');
      return;
    }
    var msg = null;
    state.state = state.state.trim();
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");

    if (this.operation == 'add') {

      state.createdby = this.userid;
      msg = "Record Added Successfully";
      this.stateservice.Post(state).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.stateModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      state.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.stateservice.Put(state).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.stateModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.stateForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.stateForm.value.active = 1;
    } else {
      this.stateForm.value.active = 0
    }
  }

  OpenConfirmTemplate(state, template: TemplateRef<any>) {
    if (state.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.state = state;

          this.Delete();

        }
       
      });

  }


  Delete() {
    var msg;
    if (this.state.active == 0) {
      this.state.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.state.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.state.modifiedby = this.userid;
    this.stateservice.Delete(this.state).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }



  hidePopup() {
    this.stateModalRef.hide();
  }
  openStateModal(template: TemplateRef<any>, type, state ?: State) {
    this.operation = type
   
    if (type == 'update') {
      this.stateForm.controls['stateid'].setValue(state.stateid);
      this.stateForm.controls['state'].setValue(state.state);
      this.stateForm.controls['active'].setValue(state.active);
      this.state = state;
    }
    if (type == 'add') {
      this.stateForm.controls['stateid'].setValue(0);
      this.stateForm.controls['state'].setValue('');
      this.stateForm.controls['active'].setValue(1);
    }
    this.stateModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }




}
